module.exports = __webpack_public_path__ + "img/iMoje.51bc48d.png";